import { html } from '../lib/html.js';
import { icon } from '../lib/icons.js';
import { getIndex } from '../lib/content.js';
import { topbar } from '../components/chrome.js';

export default async function concepts() {
  const idx = getIndex();
  return {
    title: 'Key ideas',
    html: html`<div>
      ${topbar({ back: '/explore', title: 'Key ideas' })}
      <header class="wrap page-head">
        <p class="eyebrow">${idx.glossary.length} ideas</p>
        <h1 class="h1">Key ideas</h1>
        <p class="lede">The Sanskrit words the Gita turns on, each explained in plain English.</p>
        <div class="search-field" style="margin-top:20px">
          ${icon('search', { size: 20 })}
          <label class="sr-only" for="concept-filter">Filter ideas</label>
          <input class="input" id="concept-filter" type="search" placeholder="Filter, e.g. karma or desire" autocomplete="off">
        </div>
      </header>
      <div class="wrap">
        <ul class="list concept-list" data-list>
          ${idx.glossary.map((g) => html`<li data-text="${`${g.term} ${g.iast} ${g.short}`.toLowerCase()}"><a class="list__item" href="/concept/${g.id}">
            <span class="concept-list__sa deva" lang="sa" aria-hidden="true">${g.sa}</span>
            <span class="list__body"><span class="list__title">${g.term}</span><span class="list__sub">${g.short}</span></span>
            <span class="list__trail">${icon('chevron-right', { size: 18 })}</span>
          </a></li>`)}
        </ul>
        <p class="empty__text muted" data-none hidden style="margin:24px auto;text-align:center">No ideas match that. Try the full search.</p>
      </div>
    </div>`,
    mount(root) {
      const input = root.querySelector('#concept-filter');
      const items = [...root.querySelectorAll('[data-text]')];
      const none = root.querySelector('[data-none]');
      input.addEventListener('input', () => {
        const q = input.value.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
        let shown = 0;
        for (const li of items) {
          const hit = !q || li.dataset.text.normalize('NFD').replace(/[̀-ͯ]/g, '').includes(q);
          li.hidden = !hit;
          if (hit) shown++;
        }
        none.hidden = shown > 0;
      });
    },
  };
}
